export default __webpack_public_path__ + "static/artwork-bb628124f5ccab8933e5fff3d0301d18.png";